<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li v-if='tab.index === 0' class='float-left'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z"/></svg>
            </li>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content' style='z-index:1!important'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='base-code-tree-grid'>
        <dx-tree-list style='z-index:1!important'
          ref="refBasecode"
          :height='gridHeight'
          :data-source="basecodeList"
          :autoExpandAll='true'
          :show-borders="true" :showRowLines = 'true'
          :column-auto-width="true"
          :hover-state-enabled = "true"
          key-expr="코드"
          parent-id-expr="상위코드"
          :focused-row-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="nextColumn"
          @init-new-row="onInitNewRow"
          @row-inserted='onRowInserted'
          @row-updated='onRowUpdated'
          @row-removed='onRowRemoved'
          @toolbar-preparing='onToolbarPreparing'
          @editor-preparing='onEditorPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxEditing
            :allow-adding="isAdding"
            :allow-updating="isUPdate"
            :allow-deleting="isUPdate"
            :use-icons="true"
            mode="row"
          />

          <dx-column
            data-field="코드"
            caption="코드"
            sort-order='desc'
            :allowEditing='isIdEdit'
            :allow-sorting="true"
          />
          <dx-column
            data-field="코드명"
            caption="코드명"
            :allow-sorting="true"
          />
          <dx-column
            data-field="설명"
            caption="설명"
            :allow-sorting="false"
          />
          <dx-column
            data-field="상위코드"
            caption="상위코드"
            :allow-sorting="false"
            :allowEditing='false'
          />
          <dx-column
            data-field="사용유무"
            caption="사용유무"
            :allow-sorting="false"
            width='150'
          />
          <dx-column
            data-field="삭제유무"
            caption="삭제유무"
            :allow-sorting="false"
            width='150'
          />
          <DxColumn
            caption="수정일"
            :allowEditing='false'
            :allow-sorting="false"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxColumn
            caption="등록일"
            :allowEditing='false'
            :allow-sorting="false"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <DxPaging :enabled="false"/>
        </dx-tree-list>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import { DxTreeList, DxColumn, DxSearchPanel, DxScrolling, DxPaging, DxEditing } from 'devextreme-vue/tree-list'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: '공통코드관리',
          index: 0
        }
      ],
      basecodeList: null,
      gridHeight: null,
      nodeExpandBtn: null,
      isIdEdit: false
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxColumn,
    DxTabPanel,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
    DxEditing
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }

    this.refreshbasecodeList()
  },
  mounted () {
    this.$Q('.sub-tab-wrap').css('width', (window.innerWidth - ConstDef.LEFT_MENU_WIDTH - 40) + 'px')
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isAdding (e) {
      if (e.row.data.상위코드 === null) {
        return true
      }
      return false
    },
    isUPdate (e) {
      if (e.row.data.상위코드 === null || e.row.data.코드 === ConstDef.설비중단코드) {
        return false
      }
      return true
    },
    onEditorPreparing (e) {
      if (e.dataField === '코드명' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (e) {
      if (e.data.상위코드 === '0' || e.data.상위코드 === 0) {
        e.data.상위코드 = null
      }
      e.data.사용유무 = true
      e.data.삭제유무 = false
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.nowTimestamp()
      row.data.updateid = row.data.createid = this.userInfo.userId

      this.$_sp.runInsertSqlProc('공통코드', null, [AppLib.deleteUnderlineKey(row.data)])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {
      console.log(row)
      const self = this.$_sp.runDeleteSqlProc('공통코드', [{ 코드: row.data.코드 }])
      const child = this.$_sp.runDeleteSqlProc('공통코드', [{ 상위코드: row.data.코드 }])
      axios.all([self, child])
        .then(axios.spread((...reponse) => {
          this.$snotify.info('삭제되었습니다.')
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.nowTimestamp()
      row.data.updateid = this.userInfo.userId
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('공통코드', ['코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            icon: 'chevronup',
            type: 'default',
            text: '노드 축소',
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.nodeExpandBtn = args.component
            },
            onClick: (args) => {
              console.log(args)
              let vm = this
              if (this.nodeExpandBtn.option().text === '노드 축소') {
                this.$refs.refBasecode.instance.forEachNode(function (node) {
                  vm.$refs.refBasecode.instance.collapseRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장' })
              } else {
                this.$refs.refBasecode.instance.forEachNode(function (node) {
                  vm.$refs.refBasecode.instance.expandRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevronup', text: '노드 축소' })
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '갱신',
            icon: 'refresh',
            focusStateEnabled: true,
            onClick: (args) => {
              this.refreshbasecodeList()
            }
          }
        }
      )
    },
    refreshbasecodeList () {
      this.isLoading = true
      if (this.userInfo.userId === 'SYSTEM') {
        this.$_sp.runNoEncodeFindProc('spFindAllBaseCodeByNoScode', {})
          .then((data) => {
            this.basecodeList = this.$_.sortBy(this.$_sp.MakeModel(data), '코드')
            this.gridHeight = (screen.height - 250) * 0.95
            // console.log(this.basecodeList)
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      } else {
        this.$_sp.runNoEncodeFindProc('spFindAllBaseCodeByNotInSystemCode', {})
          .then((data) => {
            this.basecodeList = this.$_.sortBy(this.$_sp.MakeModel(data), '코드')
            this.gridHeight = (screen.height - 250) * 0.95
            console.log(this.basecodeList)
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
.base-code-tree-grid{
  .dx-treelist-addrow-button {
    display: none;
  }
}
</style>
